/**
 * O NÚMERO NO ITEM "CONCILIAÇÃO" DO MENU — quantos lances do extrato esperam o dono.
 *
 * Mesma fonte do topo da lista (`/fiscal/conciliacao-lista/resumo`), para o menu nunca
 * discordar da tela. Zero = nada aparece: "você nem entra". Mora em arquivo próprio porque
 * `Layout.tsx` está no inventário do portão de tamanho e só pode encolher — lá entra uma
 * linha só.
 */
import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../hooks/useAuth";
import { useEmpresaAtivaOpcional } from "../hooks/useEmpresaAtiva";
import { apiFetch } from "../lib/api";
import { cn } from "../lib/utils";

export function useEsperamNaConciliacao(ativo: boolean) {
  const { getAccessToken } = useAuth();
  const emp = useEmpresaAtivaOpcional();
  const empresaId = emp?.ativa?.id;
  const q = useQuery({
    queryKey: ["conciliacao-lista-resumo", empresaId],
    queryFn: () => apiFetch<{ data: { esperam?: number } | null }>("/fiscal/conciliacao-lista/resumo", getAccessToken()).then((r) => r.data),
    enabled: ativo && !!empresaId,
    staleTime: 60 * 1000,
    refetchInterval: 60 * 1000,
  });
  return q.data?.esperam ?? 0;
}

export function BadgeDaConciliacao({ mostrarLabels, ativo }: { mostrarLabels: boolean; ativo: boolean }) {
  const esperam = useEsperamNaConciliacao(ativo);
  if (!ativo || esperam <= 0) return null;
  return (
    <span
      className={cn(
        "rounded-full bg-[hsl(var(--warn))] text-white text-[10px] font-bold leading-none flex items-center justify-center",
        mostrarLabels ? "px-1.5 py-0.5 min-w-[18px]" : "absolute top-1 right-1 h-2 w-2 p-0",
      )}
      title={`${esperam} lance(s) do extrato esperam você`}
    >
      {mostrarLabels ? (esperam > 99 ? "99+" : esperam) : ""}
    </span>
  );
}
